// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__6pXjm","featured":"Card_featured__p5QoD"};